





























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AdminLayout extends Vue {
  @Prop()
  breadcrumbs!: any
}
